import type { DraftStore } from './types';
import { WebDraftStore } from './webStore';

let store: DraftStore | null = null;

/** Taslaklar tarayıcının IndexedDB deposunda (fotoğraflar dahil) tutulur. */
export async function draftStore(): Promise<DraftStore> {
  store ??= new WebDraftStore();
  return store;
}

/** Test için: depo enjeksiyonu. */
export function setDraftStore(s: DraftStore): void {
  store = s;
}

/**
 * Tarayıcıdan kalıcı depolama ister; böylece disk dolduğunda taslaklar otomatik silinmez.
 * Destek yoksa sessizce geçer (iOS Safari ana ekran uygulamalarında depolama zaten kalıcıdır).
 */
export async function requestPersistentStorage(): Promise<boolean> {
  try {
    if (navigator.storage?.persisted && (await navigator.storage.persisted())) return true;
    return (await navigator.storage?.persist?.()) ?? false;
  } catch {
    return false;
  }
}
